import PropTypes from "prop-types";
import { useState } from "react";
import Title from "components/shared/stays/Title";
import Text from "components/shared/stays/Text";
import IconPlus from "solar/icons/IconPlus";
import IconMinus from "solar/icons/IconMinus";
import styles from "components/shared/stays/Counter.module.scss";

export default function Counter({
  title,
  hint,
  initialCount,
  setCurrentCount,
  minCount,
}) {
  const [count, setCount] = useState(initialCount);

  function decrement() {
    setCurrentCount(count - 1);
    setCount((prevState) => prevState - 1);
  }

  function increment() {
    setCurrentCount(count + 1);
    setCount((prevState) => prevState + 1);
  }

  return (
    <div className={styles.component}>
      <div className={styles.name}>
        <Title size={5}>{title}</Title>
        {hint && <Text size={2}>{hint}</Text>}
      </div>
      <div className={styles.selector}>
        <button
          type="button"
          onClick={decrement}
          disabled={count <= minCount}
          className={styles.button}
        >
          <span className={styles.icon}>
            <IconMinus />
          </span>
        </button>
        <div className={styles.count}>
          <Title size={5}>{count}</Title>
        </div>
        <button type="button" onClick={increment} className={styles.button}>
          <span className={styles.icon}>
            <IconPlus />
          </span>
        </button>
      </div>
    </div>
  );
}

Counter.propTypes = {
  initialCount: PropTypes.number,
  title: PropTypes.node.isRequired,
  hint: PropTypes.string,
  minCount: PropTypes.number,
  setCurrentCount: PropTypes.func,
};

Counter.defaultProps = {
  initialCount: 0,
  hint: null,
  minCount: 0,
  setCurrentCount: null,
};
